// extracted by mini-css-extract-plugin
export default {"main":"LikeComponent_main__lRp9J","left":"LikeComponent_left__ZEzoT"};